// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"89531311","498":"eb5803f4"}[chunkId] + ".chunk.js";
};